<template>
    <div class="sky-input-button">
        <itemSearch v-bind="$attrs" v-on="$listeners">
            <el-input ref="input" :type="inputType" :value="selfData" :size="size" @change="change" @input="input"
                @blur="blur" v-bind="$attrs" :placeholder="placeholder" validate-event v-focus="focus">
                <template v-if="scope && scope.vSlot" :slot="scope.vSlot">{{ scope.slotProp }}</template>
            </el-input>
            <!-- <el-button v-if="type=='phone'" @click="bindPhoneNumber()" size="medium" type="primary" style="margin-left: 15px" :loading="btnLoading"> 绑定手机号</el-button> -->
            <el-button @click="launchWhatsAppSignup()" size="medium" type="primary" style="margin-left: 15px">创建WABA</el-button>
        </itemSearch>
    </div>
</template>
<script>
import formStore from '@/mixins/formStore.js';
export default {
    name: 'sky-input-button',
    props: {
        toolContent: String,
        placeholder: {
            default: '',
        },
        inputType: {
            type: String,
            value: 'text',
        },
        size: String,
        scope: {
            type: Object,
        },
        focus: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: ''
        }
    },
    mixins: [formStore],
    data() {
        return {
            val: '',
            btnLoading: false
        };
    },
    methods: {
        change(val) {
            console.log(this.type)
            this.selfData = val;
            !this.delay && this.setVal();
            this.$emit('change', val);
            this.scope && this.scope.change && this.scope.change(val);
        },
        input(val) {
            this.selfData = val;
        },
        blur() {
            this.$emit('blur');
        },
        launchWhatsAppSignup() {
            this.$emit('launchWhatsAppSignup')
        },
        // bindPhoneNumber() {
        //     console.log(this.selfData)
        //     if(this.selfData) {
        //         this.btnLoading = true
        //     }
        //     this.$emit('bindPhoneNumber', this.resetLoading)
        // },
        resetLoading() {
            this.btnLoading = false
        }
    },
    directives: {
        focus: {
            update(el, data) {
                // 重点注意这里 当前元素是div  所以要查到子元素中的input
                const dom = el.querySelector('input') || el.querySelector('textarea');
                if (data.value) dom.focus();
            },
        },
    },
};
</script>
<style scoped lang="scss"></style>
